import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
  constructor() {}

  public exportAsExcelFile(
    json: any[],
    excelFileName: string,
    dateColumnKeyIndex?: number[],
    columnWidths?: number[]
  ): void {
    const myworksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    // Header Style
    const headerStyle = {
      font: {
        color: { rgb: 'FFFFFF' },
        bold: true,
      },
      fill: {
        patternType: 'solid',
        fgColor: { rgb: '1F4E78' },
      },
    };

    const headerKeys = Object.keys(json[0]);
    headerKeys.forEach((key, index) => {
      const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
      if (!myworksheet[cellAddress]) myworksheet[cellAddress] = {};
      myworksheet[cellAddress].s = headerStyle;
    });

    // Date-time format for specific columns
    if (dateColumnKeyIndex && dateColumnKeyIndex.length > 0) {
      dateColumnKeyIndex.forEach((colIndex) => {
        if (colIndex !== -1) {
          for (let row = 1; row <= json.length; row++) {
            // Start at row 1 to skip the header
            const cellAddress = XLSX.utils.encode_cell({ c: colIndex, r: row });
            if (myworksheet[cellAddress]) {
              myworksheet[cellAddress].z = 'yyyy-mm-dd hh:mm:ss'; // Date-time format
            }
          }
        }
      });
    }

    // Set column widths if provided
     if (columnWidths) {
      myworksheet['!cols'] = columnWidths.map(width => ({ wpx: width }));
    }

    // Create the workbook
    const myworkbook: XLSX.WorkBook = {
      Sheets: { data: myworksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(myworkbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_exported' + EXCEL_EXTENSION);
  }
}
